import { Controller } from "react-hook-form";
import {
  Select,
  MenuItem,
  TextField,
  ListSubheader,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useState, useRef, useEffect } from "react";

const SearchableSelect = ({
  control,
  data,
  name,
  noDefault = false,
  optionKey = "key", // default property name for option value
  optionLabel = "value", // default property name for option label
  isReadOnly = false, // prop to make the select read-only
  ref = null, // ref for the select input
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const searchRef = useRef(null);

  const filteredData = data?.filter((item) =>
    item?.[optionLabel]?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      searchRef.current?.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <Select
          id={name}
          fullWidth
          size="small"
          displayEmpty
          ref={ref}
          disabled={isReadOnly} // Disable the select if isReadOnly is true
          value={field.value || ""}
          onChange={(e) => {
            field.onChange(e.target.value);
            setSearchTerm(""); // Reset search after selection
          }}
          MenuProps={{
            PaperProps: {
              style: { maxHeight: 300 },
              onKeyDown: (e) => {
                e.stopPropagation();
              },
            },
          }}
          inputProps={{ "aria-label": "Without label" }}
        >
          <ListSubheader>
            <TextField
              size="small"
              placeholder="Search"
              fullWidth
              inputRef={searchRef}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </ListSubheader>

          {!noDefault && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}

          {filteredData?.map((item, index) => (
            <MenuItem key={index} value={item?.[optionKey]}>
              {item?.[optionLabel]}
            </MenuItem>
          ))}

          {filteredData?.length === 0 && (
            <MenuItem disabled>
              <em>No results found</em>
            </MenuItem>
          )}
        </Select>
      )}
    />
  );
};

export default SearchableSelect;
